import { CountryWages } from "./countryWagesEnum";

export const PERSONAL_CAR_EUR_PER_KILOMETER = 0.4;
export const COMPANY_CAR_EUR_PER_KILOMETER = 0;

const thisYear = new Date().getFullYear();
export const YEARS_LIST = [
  {
    year: thisYear - 1
  },
  {
    year: thisYear
  },
  {
    year: thisYear + 1
  },
  {
    year: thisYear + 2
  },
  {
    year: thisYear + 3
  },
  {
    year: thisYear + 4
  },
  {
    year: thisYear + 5
  }
];

export const TRIP_PURPOSE_LIST = [
  {
    id: 1,
    name: "Projekt"
  },
  {
    id: 2,
    name: "Edukacija"
  },
  {
    id: 3,
    name: "Konferencija"
  },
  {
    id: 4,
    name: "Ostalo"
  }
];

export const CAR_LIST = [
  {
    id: 2,
    name: "Osobnim automobilom"
  },
  {
    id: 3,
    name: "Službenim automobilom"
  }
];

export const VEHICLES_LIST = [
  {
    id: 1,
    name: "Avionom"
  },
  // expand with personal and company car
  ...CAR_LIST,
  {
    id: 4,
    name: "Autobusom"
  },
  {
    id: 5,
    name: "Vlakom"
  }
];

export const COUNTRIES_LIST = [
  {
    id: 1,
    name: "Hrvatska",
    shortName: "HR",
    currency: "EUR",
    wageAmount: CountryWages.CRO
  },
  {
    id: 2,
    name: "Njemačka",
    shortName: "DEU",
    currency: "EUR",
    wageAmount: CountryWages.DEU
  },
  {
    id: 3,
    name: "Austrija",
    shortName: "AUT",
    currency: "EUR",
    wageAmount: CountryWages.AUT
  },
  {
    id: 4,
    name: "Belgija",
    shortName: "BEL",
    currency: "EUR",
    wageAmount: CountryWages.BEL
  },
  {
    id: 5,
    name: "Bosna i Hercegovina",
    shortName: "BIH",
    currency: "EUR",
    wageAmount: CountryWages.BIH
  },
  {
    id: 6,
    name: "Češka",
    shortName: "CZE",
    currency: "EUR",
    wageAmount: CountryWages.CZE
  },
  {
    id: 7,
    name: "Danska",
    shortName: "DEN",
    currency: "EUR",
    wageAmount: CountryWages.DEN
  },
  {
    id: 8,
    name: "Estonija",
    shortName: "EST",
    currency: "EUR",
    wageAmount: CountryWages.EST
  },
  {
    id: 9,
    name: "Finska",
    shortName: "FIN",
    currency: "EUR",
    wageAmount: CountryWages.FIN
  },
  {
    id: 10,
    name: "Grčka",
    shortName: "GRE",
    currency: "EUR",
    wageAmount: CountryWages.GRE
  },
  {
    id: 11,
    name: "Irska",
    shortName: "IRL",
    currency: "EUR",
    wageAmount: CountryWages.IRL
  },
  {
    id: 12,
    name: "Island",
    shortName: "ISL",
    currency: "EUR",
    wageAmount: CountryWages.ISL
  },
  {
    id: 13,
    name: "Izrael",
    shortName: "ISR",
    currency: "USD",
    wageAmount: CountryWages.ISR
  },
  {
    id: 14,
    name: "Latvija",
    shortName: "LAT",
    currency: "EUR",
    wageAmount: CountryWages.LAT
  },
  {
    id: 15,
    name: "Litva",
    shortName: "LIT",
    currency: "EUR",
    wageAmount: CountryWages.LIT
  },
  {
    id: 16,
    name: "Nizozemska",
    shortName: "NED",
    currency: "EUR",
    wageAmount: CountryWages.NED
  },
  {
    id: 17,
    name: "Norveška",
    shortName: "NOR",
    currency: "EUR",
    wageAmount: CountryWages.NOR
  },
  {
    id: 18,
    name: "Poljska",
    shortName: "POL",
    currency: "EUR",
    wageAmount: CountryWages.POL
  },
  {
    id: 19,
    name: "Portugal",
    shortName: "POR",
    currency: "EUR",
    wageAmount: CountryWages.POR
  },
  {
    id: 20,
    name: "Rumunjska",
    shortName: "ROM",
    currency: "EUR",
    wageAmount: CountryWages.ROM
  },
  {
    id: 21,
    name: "Rusija",
    shortName: "RUS",
    currency: "USD",
    wageAmount: CountryWages.RUS
  },
  {
    id: 22,
    name: "Sjedinjene Američke države",
    shortName: "USA",
    currency: "USD",
    wageAmount: CountryWages.USA
  },
  {
    id: 23,
    name: "Slovačka",
    shortName: "SVK",
    currency: "EUR",
    wageAmount: CountryWages.SVK
  },
  {
    id: 24,
    name: "Slovenija",
    shortName: "SLN",
    currency: "EUR",
    wageAmount: CountryWages.SLN
  },
  {
    id: 25,
    name: "srbija",
    shortName: "SRB",
    currency: "EUR",
    wageAmount: CountryWages.SRB
  },
  {
    id: 26,
    name: "Crna Gora",
    shortName: "MNT",
    currency: "EUR",
    wageAmount: CountryWages.MNT
  },
  {
    id: 27,
    name: "Španjolska",
    shortName: "ESP",
    currency: "EUR",
    wageAmount: CountryWages.ESP
  },
  {
    id: 28,
    name: "Švicarska",
    shortName: "CHE",
    currency: "EUR",
    wageAmount: CountryWages.CHE
  },
  {
    id: 29,
    name: "Švedska",
    shortName: "SWE",
    currency: "EUR",
    wageAmount: CountryWages.SWE
  },
  {
    id: 30,
    name: "Italija",
    shortName: "ITA",
    currency: "EUR",
    wageAmount: CountryWages.ITA
  },
  {
    id: 31,
    name: "Turska",
    shortName: "TUR",
    currency: "EUR",
    wageAmount: CountryWages.TUR
  },
  {
    id: 32,
    name: "Ukrajina",
    shortName: "UKR",
    currency: "USD",
    wageAmount: CountryWages.UKR
  },
  {
    id: 33,
    name: "Velika Britanija",
    shortName: "UK",
    currency: "EUR",
    wageAmount: CountryWages.UK
  },
  {
    id: 34,
    name: "Inozemstvo",
    shortName: "DE",
    currency: "EUR",
    wageAmount: CountryWages.DEU
  }
];

export const ACCOMMODATION_PAYMENT = [
  {
    id: 1,
    name: "Vlastiti smještaj",
    coefficient: 1
  },
  {
    id: 2,
    name: "Na trošak firme",
    coefficient: 0.6862745098 // 350/510
  },
  {
    id: 3,
    name: "Posebna dnevnica na trošak firme",
    coefficient: 1
  }
];

export const ACCOMMODATION_TYPE = [
  {
    id: 1,
    name: "Samo doručak",
    coefficient: 1
  },
  {
    id: 2,
    name: "Polu pansion",
    coefficient: 0.7
  },
  {
    id: 3,
    name: "Puni pansion",
    coefficient: 0.4
  }
];

export const KILOMETERS_ERROR =
  "Greška: broj početnog stanja kilometara je veći od završnog stanja brojila";

export const PAYMENT_METHODS = [
  {
    id: 1,
    name: "Sredstva poslodavca: virman"
  },
  {
    id: 2,
    name: "Sredstva poslodavca: kartica"
  },
  {
    id: 3,
    name: "Osobna sredstva: gotovina"
  },
  {
    id: 4,
    name: "Osobna sredstva: kartica"
  }
];

export const ADDITIONAL_COST_TYPES = [
  {
    id: 1,
    name: "Let"
  },
  {
    id: 2,
    name: "Autobus"
  },
  {
    id: 3,
    name: "Vlak"
  },
  {
    id: 4,
    name: "Javni prijevoz"
  },
  {
    id: 5,
    name: "Taxi"
  },
  {
    id: 6,
    name: "Smještaj"
  },
  {
    id: 7,
    name: "Ostalo"
  }
];
